<template>
    <div id="contenedor-contrato-catalogo-toolbar">
      <v-toolbar
      v-if="mixValidaScopesActions(1)"
        flat
        color="transparent">
        <v-spacer></v-spacer>
        <custom-button
          label="Agregar Partida"
          iconText="mdi-plus"
          tipo="agregar"
          @click="agregarPartida">
        </custom-button>
        <opciones
        :catalogoConceptos="catalogoConceptos"
        :contrato="contrato"
          v-on:cargarCatalogo="cargarCatalogo"
          v-on:borrarCatalogo="borrarCatalogo"
          v-on:actualizarCatalogo="actulizarCatalogo"></opciones>
      </v-toolbar>
    </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ContratoCatalogoToolBar',
  props: {
    catalogoConceptos: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
    Opciones,
  },
  data() {
    return {};
  },
  methods: {
    cargarCatalogo() {
      this.$emit('cargarCatalogo');
    },
    actulizarCatalogo() {
      this.$emit('actualizarCatalogo');
    },
    agregarPartida() {
      this.$emit('agregarPartida');
    },
    borrarCatalogo() {
      this.$emit('borrarCatalogo');
    },
  },
};
</script>

<style lang="scss">

</style>
